import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { observable, action } from 'mobx';
import { task } from 'mobx-task';
import { validationContext, required, func } from 'validx';

/**
 * State used for editing team info.
 */
var TeamInfoViewState = (_dec = action.bound, _dec2 = task.resolved, _dec3 = task.resolved, _dec4 = task.resolved, _class = /*#__PURE__*/function () {
  function TeamInfoViewState(_ref) {
    var team = _ref.team,
      flashMessageStore = _ref.flashMessageStore,
      teamStore = _ref.teamStore,
      onViewList = _ref.onViewList;
    _classCallCheck(this, TeamInfoViewState);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "slug", _descriptor2, this);
    _initializerDefineProperty(this, "teamPurpose", _descriptor3, this);
    _initializerDefineProperty(this, "streetAddress", _descriptor4, this);
    _initializerDefineProperty(this, "city", _descriptor5, this);
    _initializerDefineProperty(this, "state", _descriptor6, this);
    _initializerDefineProperty(this, "zipCode", _descriptor7, this);
    _initializerDefineProperty(this, "country", _descriptor8, this);
    this.validation = validationContext(this, {
      name: [required('Team name is required'), func(function (_ref2) {
        var value = _ref2.value;
        return value.length <= 50;
      }, "Name can't be more than 50 characters")]
    });
    this.team = team;
    this.teamStore = teamStore;
    this.flashMessageStore = flashMessageStore;
    this.saveInfo = this.saveInfo.bind(this);
    this.onViewList = onViewList;
  }
  return _createClass(TeamInfoViewState, [{
    key: "activate",
    value: (
    /**
     * Activates the state.
     */
    function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.set({
                name: this.team.name,
                slug: this.team.slug,
                teamPurpose: this.team.teamPurpose,
                streetAddress: this.team.address && this.team.address.streetAddress,
                zipCode: this.team.address && this.team.address.zipCode,
                city: this.team.address && this.team.address.city,
                state: this.team.address && this.team.address.state,
                country: this.team.address && this.team.address.country
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }())
  }, {
    key: "picture",
    get: function get() {
      return this.team.imageUrl;
    }

    /**
     * Sets the props on the state.
     *
     * @param {*} props
     */
  }, {
    key: "set",
    value: function set(props) {
      Object.assign(this, props);
      return this;
    }
  }, {
    key: "deleteTeam",
    value: function () {
      var _deleteTeam = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var msg;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              msg = this.flashMessageStore.create({
                inProgress: true,
                message: 'Deleting...'
              });
              _context2.prev = 1;
              _context2.next = 4;
              return this.teamStore.updateTeam(this.team.id, {
                inactive: true
              });
            case 4:
              msg.done('Team deleted!').autoDismiss();
              this.onViewList();
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              msg.forError(_context2.t0);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 8]]);
      }));
      function deleteTeam() {
        return _deleteTeam.apply(this, arguments);
      }
      return deleteTeam;
    }()
    /**
     * Saves the team info.
     */
  }, {
    key: "saveInfo",
    value: (function () {
      var _saveInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var msg;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // Trim the name.
              this.set({
                name: this.name ? this.name.trim() : '',
                teamPurpose: this.teamPurpose ? this.teamPurpose.trim() : '',
                streetAddress: this.streetAddress ? this.streetAddress.trim() : '',
                city: this.city ? this.city.trim() : '',
                state: this.state ? this.state.trim() : '',
                zipCode: this.zipCode ? this.zipCode.trim() : '',
                country: this.country ? this.country.trim() : ''
              });
              if (this.validation.reset().validate().isValid) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              msg = this.flashMessageStore.create({
                inProgress: true,
                message: 'Saving details'
              });
              _context3.prev = 4;
              _context3.next = 7;
              return this.teamStore.updateTeam(this.team.id, {
                name: this.name,
                team_purpose: this.teamPurpose,
                address: {
                  streetAddress: this.streetAddress,
                  zipCode: this.zipCode,
                  city: this.city,
                  state: this.state,
                  country: this.country
                }
              });
            case 7:
              msg.done('Team details saved!').autoDismiss();
              _context3.next = 14;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](4);
              msg.forError(_context3.t0);
              console.error(_context3.t0);
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 10]]);
      }));
      function saveInfo() {
        return _saveInfo.apply(this, arguments);
      }
      return saveInfo;
    }())
  }, {
    key: "uploadPicture",
    value: function () {
      var _uploadPicture = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(file) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.teamStore.changeAvatar(this.team.id, file));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function uploadPicture(_x) {
        return _uploadPicture.apply(this, arguments);
      }
      return uploadPicture;
    }()
  }]);
}(), _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "slug", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "teamPurpose", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "streetAddress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "city", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "state", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "zipCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "country", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "set", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "set"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteTeam", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "deleteTeam"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveInfo", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "saveInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "uploadPicture", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "uploadPicture"), _class.prototype), _class);
export { TeamInfoViewState as default };
//# sourceMappingURL=TeamInfoViewState.js.map
